import React, { FC } from 'react';
import { useLazyLoading, Loading } from '../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Routes } from '../../utils';
import moment from 'moment';
import { faComments, faCommentDots } from '@fortawesome/free-regular-svg-icons';

interface LooseObject {
    [key: string]: any;
}

interface ConversationListItemProps {
    abortRequest: () => void;
    conversations: LooseObject[];
    refetch?: () => void;
    isLoading: boolean;
    isEndOfResults: boolean;
    history: any;
    onLoadMore: () => void;
}

const ConversationListItem: FC<ConversationListItemProps> = ({
    abortRequest,
    conversations,
    refetch,
    isLoading,
    isEndOfResults,
    history,
    onLoadMore,
}: ConversationListItemProps): React.ReactElement => {
    const { handleScroll, scrollPos } = useLazyLoading(
        'messageConversationList',
        isLoading,
        isEndOfResults,
        onLoadMore,
    );

    if (isLoading) {
        return <Loading />;
    }

    const doc: HTMLElement | null = document.getElementById('messageConversationList');
    if (doc) {
        doc.scroll(0, scrollPos);
    }

    const redirectToConversationHandler = (
        event: any,
        conversation: LooseObject,
        conversationId: string,
        driverId: number,
    ) => {
        if (conversation.isGrupal) {
            localStorage.setItem(
                'driverData_' + conversationId,
                JSON.stringify({
                    isGroupAl: true,
                    cellPhone: 'Group Message',
                    name: conversation.conversationName,
                    driver: {
                        markAllRead: true,
                        conversationId: conversation.conversationId,
                        isGrupAl: conversation.isGrupal,
                        ...conversation,
                    },
                }),
            );
            history(`${Routes.MESSAGES.route}${conversationId}`);
        } else {
            localStorage.setItem(
                'driverData_' + conversation.driver.id,
                JSON.stringify({
                    name: conversation.driver.name,
                    cellPhone: conversation.driver.driverCellNumber,
                    resultId: conversation.driver.id,
                    conversationId: conversation.conversationId,
                    driver: {
                        markAllRead: true,
                        conversationId: conversation.conversationId,
                        isGrupAl: conversation.isGrupal,
                        resultId: conversation.driver.id,
                        driverName: conversation.driver.name,
                        ...conversation,
                    },
                }),
            );
            history(`${Routes.MESSAGES.route}${conversation.driver.id}`);
        }
    };
    if (conversations.length > 0) {
        return (
            <div id="messageConversationList" className="Message-Container" onScroll={handleScroll}>
                {conversations.map((conversation, index) => (
                    <div
                        className="Message-Detail"
                        key={`${conversation.conversationId}-${index}`}
                        onClick={event =>
                            redirectToConversationHandler(
                                event,
                                conversation,
                                conversation.conversationId,
                                conversation.driver.id,
                            )
                        }
                    >
                        <div className="d-flex flex-column justify-content-between my-flex-container col-md-7 p-2">
                            <span className="by">{conversation.driverName}</span>
                            <p className="message">{conversation.bodyMessage}</p>
                        </div>
                        <div className="d-flex flex-column justify-content-between my-flex-container col-md-5">
                            <div className="row mr-0 ml-0 justify-content-end">
                                <div className="date">
                                    {moment
                                        .utc(conversation.creationDate)
                                        .local()
                                        .format('lll')}{' '}
                                    <span className="conv-icon">
                                        <FontAwesomeIcon
                                            icon={conversation.messageType == 'Sms' ? faCommentDots : faComments}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    } else {
        return (
            <div className="no-conversation my-auto text-center justify-content-center align-self-center">
                No Message Found!!
            </div>
        );
    }
};

export default ConversationListItem;
